import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { Coverage } from "@graphql/api";
import PropertiesGrid from "@covertree/ui/content/PropertiesGrid";
import { mapHomeType } from "./utils";
import { formatCurrency } from "@covertree/utils";

interface Props {
  coverage: Pick<Coverage, "id" | "coverageDetails">;
  expanded?: boolean;
  width?: string;
}
export default function HomeDetails({
  coverage,
  width,
  expanded = false,
}: Props) {
  return (
    <Box px={1} width={width}>
      <Accordion
        defaultExpanded={expanded}
        sx={{
          border: "none",
          backgroundColor: "secondary.contrastText",
          "&.Mui-expanded": {
            margin: 0,
          },
          "&:before": {
            display: "none",
          },
        }}>
        <AccordionSummary
          sx={{
            px: 3,
            "& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded":
              {
                my: 3,
              },
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`${coverage.id}-home-details-content`}
          id={`${coverage.id}-home-details-header`}>
          <Typography>Home Details</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ pt: 0 }}>
          <PropertiesGrid
            px={1}
            pt={0}
            properties={[
              {
                label: "Occupancy",
                value: coverage.coverageDetails?.occupancy ?? "N/A",
              },
              {
                label: "Manufacturer",
                value: coverage.coverageDetails?.manufacturer || "N/A",
              },
              {
                label: "Home Type",
                value: mapHomeType(coverage.coverageDetails?.homeType),
              },
              {
                label: "Model Year",
                value: coverage.coverageDetails?.modelYear || "N/A",
              },

              {
                label: "Home Coverage Limit (Coverage\u00A0A)",
                value: coverage.coverageDetails?.homeCoverageLimit
                  ? formatCurrency(coverage.coverageDetails?.homeCoverageLimit)
                  : "N/A",
              },
              {
                label: "Other Structures Limit (Coverage\u00A0B)",
                value: coverage.coverageDetails?.otherStructuresLimit
                  ? formatCurrency(
                      coverage.coverageDetails?.otherStructuresLimit
                    )
                  : "N/A",
              },
              {
                label: "Personal Property Coverage Limit (Coverage\u00A0C)",
                value: coverage.coverageDetails?.personalPropertyLimit
                  ? formatCurrency(
                      coverage.coverageDetails?.personalPropertyLimit
                    )
                  : "N/A",
              },
              {
                label: "Personal/Premises Liability Limit (Coverage\u00A0E)",
                value: coverage.coverageDetails?.personalLiabilityLimit
                  ? formatCurrency(
                      coverage.coverageDetails.personalLiabilityLimit
                    )
                  : "N/A",
              },
              {
                label: "Medical Payments to Others Limit (Coverage\u00A0F)",
                value: coverage.coverageDetails?.medicalPaymentsLimit
                  ? formatCurrency(
                      coverage.coverageDetails?.medicalPaymentsLimit
                    )
                  : "N/A",
              },
              {
                label: "Animal Liability Limit",
                value: coverage.coverageDetails?.animalLiabilityLimit
                  ? formatCurrency(
                      coverage.coverageDetails?.animalLiabilityLimit
                    )
                  : "N/A",
              },
              {
                label: "Standard Deductible Limit",
                value: coverage.coverageDetails?.standardDeductibleLimit
                  ? formatCurrency(
                      coverage.coverageDetails?.standardDeductibleLimit
                    )
                  : "N/A",
              },
            ]}
          />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
